import axiosService from './axios-service';
import { FwVersionContentAndMetadata } from '../dtos/version.dto';

class RuleService {
    public createRule = async (customerId: number, sid: number, versionId: string, rule: any): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.post(`/api/firewall/customer/${customerId}/service/${sid}/rule`, {
            ...rule,
            externalId: versionId
        });
        return result?.data;
    };
    public updateRule = async (customerId: number, sid: number, versionId: string, rule: any): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.put(`/api/firewall/customer/${customerId}/service/${sid}/rule`, {
            ...rule,
            externalId: versionId
        });
        return result?.data;
    };

    public deleteRule = async (customerId: number, sid: number, versionId: string, rule: any): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.delete(`/api/firewall/customer/${customerId}/service/${sid}/rule`, {
            objectDisplayName: rule.displayName,
            externalId: versionId
        });
        return result?.data;
    };

    public deactivateRule = async (customerId: number, sid: number, versionId: string, rule: any, activeState: string): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.put(`/api/firewall/customer/${customerId}/service/${sid}/activate-deactivate-rule`, {
            ruleName: rule.displayName,
            externalId: versionId,
            activationState: activeState
        });
        return result?.data;
    };

}

const ruleService = new RuleService();
export default ruleService;